import { FunctionComponentType } from '@interfaces/commons/FunctionComponent'
import cn from 'classnames'

export function Box({ children, className }: FunctionComponentType) {
  const defaultClassName = 'rounded-[8px]'
  return (
    <section className={cn(defaultClassName, className)}>{children}</section>
  )
}

Box.Title = function BoxTitle({ children, className }: FunctionComponentType) {
  const defaultClassName = 'font-mitr font-medium text-secondary'
  return <h2 className={cn(defaultClassName, className)}>{children}</h2>
}

Box.Name = function BoxName({ children, className }: FunctionComponentType) {
  const defaultClassName = 'font-bold text-secondary'
  return <span className={cn(defaultClassName, className)}>{children}</span>
}

Box.Text = function BoxText({ children, className }: FunctionComponentType) {
  const defaultClassName = 'font-light text-secondary'
  return <span className={cn(defaultClassName, className)}>{children}</span>
}

Box.Label = function BoxLabel({ children, className }: FunctionComponentType) {
  const defaultClassName = 'font-light text-secondary-1'
  return <span className={cn(defaultClassName, className)}>{children}</span>
}

Box.Tag = function BoxTag({ children, className }: FunctionComponentType) {
  const defaultClassName =
    'flex justify-center items-center bg-primary rounded w-[54px] h-[24px]'
  return (
    <div className={cn(defaultClassName, className)}>
      <span className='font-bold text-white text-[12px]'>{children}</span>
    </div>
  )
}
